import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Grid from '../../../Grid'
import SingleSelect from '../../../common/Forms/SingleSelect'

const InvoiceForm = ({
  invoiceId, lineItems, productOptions, handleChange, invoiceSent,
}) => {
  const [items, setItems] = useState(lineItems)

  const handleItemChange = (item, index) => {
    setItems((prevState) => {
      const newState = prevState
      newState[index] = item
      return [...newState]
    })
  }

  const addLineItem = (event) => {
    event.preventDefault()
    setItems((prevState) => {
      prevState.push({
        quantity: 0,
        p_code: '',
        product: '',
        price: 0,
      })
      return [...prevState]
    })
  }

  useEffect(() => {
    handleChange(items)
  }, [items])

  return (
    <>
      <input name="dproject[invoice_attributes][id]" value={invoiceId || ''} readOnly hidden />
      <LineItemHeader />
      <Grid container xs={12} spacing={2}>
        {items.map((item, index) => (
          <Fragment key={index}>
            <Grid item xs={1}>
              {index + 1}
            </Grid>
            <Grid item xs={11}>
              <LineItemRow
                model={item}
                index={index}
                options={productOptions}
                handleChange={handleItemChange}
              />
            </Grid>
          </Fragment>
        ))}
      </Grid>
      <br />
      <button type="button" className="btn btn-primary" onClick={(event) => addLineItem(event)}>Add Item</button>
      { invoiceSent
        && (
        <span className="text-right pull-right">
          Invoice Sent:
          {' '}
          {invoiceSent}
        </span>
        )}
    </>
  )
}

InvoiceForm.propTypes = {
  invoiceId: PropTypes.string,
  lineItems: PropTypes.array,
  productOptions: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  invoiceSent: PropTypes.instanceOf(Date),
}

InvoiceForm.defaultProps = {
  invoiceId: null,
  lineItems: [],
  productOptions: [],
  invoiceSent: null,
}

const LineItemHeader = () => (
  <Grid container xs={12} spacing={2}>
    <Grid item xs={1}>
      Line #
    </Grid>
    <Grid item xs={11}>
      <Grid container xs={12}>
        <Grid item xs={1}>Qty</Grid>
        <Grid item xs={2}>Code</Grid>
        <Grid item xs={3}>Item Description</Grid>
        <Grid item xs={2}>File</Grid>
        <Grid item xs={1}>Unit Price</Grid>
        <Grid item xs={2}>Notes</Grid>
        <Grid item xs={1}>Delete?</Grid>
      </Grid>
    </Grid>
  </Grid>
)

const LineItemRow = ({
  model, options, index, handleChange,
}) => {
  const [id, setId] = useState(model.id)
  const [currentQuantity, setQuantity] = useState(model.quantity)
  const [currentName, setName] = useState(model.product)
  const [currentPrice, setPrice] = useState(model.price)
  const [pdfUrl] = useState(model.pdf_url)
  const [schoolLogo, setSchoolLogo] = useState(model.schoolLogo)
  const [attachment, setAttachment] = useState(model.attachments)
  const [notes, setNotes] = useState(model.notes)
  const [_destroy, setDestroy] = useState(model._destroy ? model._destroy : false)

  const [selectedProduct, setProduct] = useState({ label: model.p_code, value: model.p_code, data: {} } || { label: '', value: '' })

  const setInputs = (product) => {
    setName(product.data.name)
    setPrice(product.data.price)
    setProduct(product)
  }

  useEffect(() => {
    handleChange({
      quantity: currentQuantity,
      product: currentName,
      price: currentPrice,
      p_code: selectedProduct.value,
      pdf_url: pdfUrl,
      schoolLogo,
      attachment,
      notes,
      _destroy,
    }, index)
  }, [currentQuantity, currentName, currentPrice, selectedProduct, _destroy])

  const renderAttachments = () => (
    <>
      {model.schoolLogo && <><a href={model.schoolLogo} target="_blank" download>School Logo</a><br/></>}
      {model.attachments && <><a href={model.attachments} target="_blank" download>Attachment</a><br/></>}
    </>
  )

  return (
    <>
      <input name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][id]`} value={id} readOnly hidden />
      <Grid container xs={12} spacing={2}>
        <Grid item xs={1}>
          <input
            className="form-control"
            type="number"
            name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][quantity]`}
            value={currentQuantity}
            onChange={(event) => { setQuantity(event.target.value) }}
          />
        </Grid>
        <Grid item xs={2}>
          <ProductSelect
            handleChange={setInputs}
            index={index}
            options={options}
            selectedValue={selectedProduct}
            showCheckbox
            placeholderText="Code"
          />
        </Grid>
        <Grid item xs={3}>
          <input
            className="form-control"
            type="text"
            name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][product]`}
            value={currentName || ''}
            onChange={(event) => { setName(event.target.value) }}
          />
        </Grid>
        <Grid item xs={2}>
          {pdfUrl ? (
            <a href={pdfUrl} target="_blank" download style={{ fontSize: '12px', wordBreak: 'break-all' }}>
              {pdfUrl.split('/').pop()}
            </a>
          ) : null}
        </Grid>
        <Grid item xs={1}>
          <input
            className="form-control"
            type="number"
            name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][price]`}
            value={currentPrice || ''}
            onChange={(event) => { setPrice(event.target.value) }}
          />
        </Grid>
        <Grid item xs={2}>
          {model.notes && model.notes.split('\n').map(str => <>{str}<br/ ></>)}
        </Grid>
        <Grid item xs={1}>
          <input
            type="checkbox"
            name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][_destroy]`}
            value={_destroy}
            checked={_destroy}
            onChange={(event) => { setDestroy(event.target.checked) }}
          />
        </Grid>
      </Grid>
    </>
  )
}

LineItemRow.propTypes = {
  model: PropTypes.object,
  options: PropTypes.array,
  index: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
}

LineItemRow.defaultProps = {
  model: {
    id: null, quantity: 0, p_code: '', product: '', price: 0,
  },
  options: [{}],
  index: 0,
}

const ProductSelect = ({
  handleChange, options, selectedValue, index,
}) => {
  const updateProduct = (product) => {
    if (product !== null) {
      handleChange(product)
    }
  }

  return (
    <>
      <input
        name={(index !== null) && `dproject[invoice_attributes][lineitems_attributes][${index}][p_code]`}
        value={selectedValue && selectedValue.value}
        readOnly
        hidden
      />
      <SingleSelect
        handleChange={updateProduct}
        options={options}
        selectedValue={selectedValue}
        showCheckbox
        placeholderText="Select product"
      />
    </>
  )
}

ProductSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object,
  index: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
}

ProductSelect.defaultProps = {
  options: [{}],
  selectedValue: {},
  index: 0,
}

export default InvoiceForm
